<script>
    // import { flip } from 'svelte/animate';
    import Logo from "../components/Logo.svelte";

    import "../styles/blank.css";

    export let heading = '';
    export let text = '';
</script>

<section class="blank">
    <h1 class="blank__logo"><Logo class="blank__logo-img" /></h1>
    <div class="blank__message header">
        <h1 class="header__heading heading heading_level_1">{heading}</h1>
        <span class="header__text text">{text}</span>
    </div>
</section>
